import React, {useEffect, useMemo, useState} from 'react';
import {notification} from 'antd';
import {
    DataGridPremium,
    GridCellParams,
    gridClasses,
    GridColDef,
    GridToolbarColumnsButton,
    GridToolbarContainer,
    GridToolbarExport,
    GridToolbarFilterButton,
    GridToolbarQuickFilter,
    ruRU
} from '@mui/x-data-grid-premium';
import {Navbar} from "../../components/Navbar";
import {authAPI} from "../../services/AuthService";
import {Navigate} from "react-router-dom";
import {CreateUserModal} from "../../components/UsersScreen/CreateUserModal";
import {userAPI} from "../../services/UserService";
import {UserGridModel} from "../../models/UserGridModel";
import {UpdateUserModal} from "../../components/UsersScreen/UpdateUserModal";
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import {Button} from '@mui/material';
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";

const Context = React.createContext({name: 'UsersScreen'});

export const UserScreen: React.FC = () => {
    const CustomToolbar = () => {
        return (
            <GridToolbarContainer>
                <div style={{display: 'flex', justifyContent: 'space-between', width: window.innerWidth}}>
                    <div style={{display: 'flex'}}>
                        <Button size={'small'} onClick={() => setVisibleCreateUserModal(true)}
                                startIcon={<AddBoxOutlinedIcon/>}>Добавить</Button>
                        <Button disabled={isGettingUsersInProcess} size={'small'} onClick={() => getUsersRequest()}
                                startIcon={<RefreshOutlinedIcon/>}>Обновить</Button>
                        <GridToolbarColumnsButton/>
                        <GridToolbarFilterButton/>
                        <GridToolbarExport/>
                    </div>
                    <div style={{display: 'flex'}}>
                        <GridToolbarQuickFilter/>
                    </div>
                </div>
            </GridToolbarContainer>
        );
    }
    // Notification
    const [api, contextHolder] = notification.useNotification();
    const errorNotification = (message: string) => {
        api.error({
            message: `Ошибка`,
            description: <Context.Consumer>{({name}) => `${message}`}</Context.Consumer>,
            placement: 'topRight',
        });
    };
    const infoNotification = (message: string) => {
        api.success({
            message: `Выполнено`,
            description: <Context.Consumer>{({name}) => `${message}`}</Context.Consumer>,
            placement: 'topRight',
        });
    };
    const contextValue = useMemo(() => ({name: 'Ant Design'}), []);
    // -----
    const [getUsersRequest, {
        data: dataGetUsersRequest,
        isLoading: isGettingUsersInProcess
    }] = userAPI.useGetUsersMutation();
    const [redirectToLogin, setRedirectToLogin] = useState<boolean>(false);
    const [rows, setRows] = useState<UserGridModel[]>([]);
    const [visibleCreateUserModal, setVisibleCreateUserModal] = useState<boolean>(false);
    const [visibleUpdateUserModal, setVisibleUpdateUserModal] = useState<boolean>(false);
    const [selectedUser, setSelectedUser] = useState<UserGridModel | null>(null);
    // Return to login if reject token verify
    const [verifyTokenRequest, {status: statusVerifyTokenRequest}] = authAPI.useVerifyTokenMutation();
    useEffect(() => {
        verifyTokenRequest();
    }, [])
    useEffect(() => {
        if (statusVerifyTokenRequest === 'rejected') {
            setRedirectToLogin(true);
        }
    }, [statusVerifyTokenRequest])
    // -----
    useEffect(() => {
        const token: string | null = localStorage.getItem('token');
        if (token) getUsersRequest();
        else setRedirectToLogin(true);
    }, [])
    useEffect(() => {
        if (dataGetUsersRequest) setRows(dataGetUsersRequest);
    }, [dataGetUsersRequest])
    const columns: GridColDef[] = [{fieldName: "Логин", field: 'username'},
        {fieldName: "Имя", field: 'name'},
        {fieldName: "Фамилия", field: 'surname'},
        {fieldName: "Отчетсво", field: 'secondName'},
        {fieldName: "Роль", field: 'roleString'},
        {fieldName: "Почта", field: 'email'},
        {fieldName: "Телефон", field: 'phone'},
        {fieldName: "Объекты", field: 'objectsString'}].map((col: { fieldName: string, field: string }) => {
        return {
            field: col.field,
            headerName: col.fieldName,
            minWidth: col.field === 'username' ? 120
                : col.field === 'name' ? 140
                    : col.field === 'surname' ? 140
                        : col.field === 'secondName' ? 140
                            : col.field === 'role' ? 140
                                : col.field === 'email' ? 300
                                    : col.field === 'phone' ? 140
                                        : col.field === 'objects' ? 500
                                            : 200,
            width: col.field === 'username' ? 120
                : col.field === 'name' ? 140
                    : col.field === 'surname' ? 140
                        : col.field === 'secondName' ? 140
                            : col.field === 'role' ? 140
                                : col.field === 'email' ? 300
                                    : col.field === 'phone' ? 140
                                        : col.field === 'objects' ? 500
                                            : 200,
            editable: false,
            renderHeader: (params: any) => {
                return <div>
                    {col.fieldName}
                </div>
            },
            // renderCell: (params: any) => {
            //     if (col.field === 'objects')
            //         return params.row.objects.map((obj: any) => {
            //             return <Tag>{obj.filialAndObj}</Tag>
            //         })
            //     else if (col.field === 'role') {
            //         if (params.row.role === 1)
            //             return "Заказчик";
            //         else if (params.row.role === 0)
            //             return "Администратор";
            //         else if (params.row.role === 2)
            //             return "Исполнитель";
            //     } else
            //         return <div>{params.row[col.field]}</div>
            // },
            // valueGetter: (params) => {
            //     console.log(params)
            //     if (params.field === 'objects') {
            //         return params.value.map((ob: any) => ob.filialAndObj).join('; ');
            //     } else if (params.field === 'role') {
            //         if (params.value === 1)
            //             return "Заказчик";
            //         else if (params.value === 0)
            //             return "Администратор";
            //         else if (params.value === 2)
            //             return "Исполнитель";
            //     }
            //     return params.value;
            // },
        }
    });
    return (
        <Context.Provider value={contextValue}>
            {contextHolder}
            <Navbar/>
            <div style={{height: window.innerHeight - 110}}>
                {redirectToLogin && <Navigate to="/login" replace={false}/>}
                {visibleCreateUserModal && <CreateUserModal
                    infoNotification={infoNotification}
                    errorNotification={errorNotification}
                    getUsers={getUsersRequest}
                    setVisible={setVisibleCreateUserModal}/>}
                {(visibleUpdateUserModal && selectedUser) && <UpdateUserModal
                    infoNotification={infoNotification}
                    errorNotification={errorNotification}
                    user={selectedUser}
                    getUsers={getUsersRequest}
                    setVisible={setVisibleUpdateUserModal}/>}
                <DataGridPremium
                    localeText={ruRU.components.MuiDataGrid.defaultProps.localeText}
                    rows={rows}
                    columns={columns}
                    getRowHeight={() => 'auto'}
                    sx={{
                        [`& .${gridClasses.cell}`]: {
                            py: 1,
                        },
                    }}
                    /*@ts-ignore*/
                    pageSize={20}
                    rowsPerPageOptions={[20]}
                    disableSelectionOnClick
                    slots={{toolbar: CustomToolbar}}
                    loading={isGettingUsersInProcess}
                    onCellDoubleClick={(params: GridCellParams) => {
                        setSelectedUser(params.row);
                        setVisibleUpdateUserModal(true);
                    }}
                />
                {/*@ts-ignore*/}
                {/*<BestReactGrid*/}
                {/*    onChildDoubleTap={(e) => {*/}
                {/*        setSelectedUser(e.record.rows);*/}
                {/*        setVisibleUpdateUserModal(true);*/}
                {/*    }}*/}
                {/*    display="locked"*/}
                {/*    rows={rows}*/}
                {/*    store={{*/}
                {/*        autoLoad: true,*/}
                {/*        loadData: async function (params) {*/}
                {/*            let myHeaders = new Headers();*/}
                {/*            myHeaders.append("Authorization", `Bearer ${localStorage.getItem('token')}`);*/}

                {/*            let requestOptions = {*/}
                {/*                method: 'GET',*/}
                {/*                headers: myHeaders,*/}
                {/*                redirect: 'follow'*/}
                {/*            };*/}

                {/*            // @ts-ignore*/}
                {/*            let response = await fetch(`${secure}://${host}${port}/users/all`, requestOptions)*/}

                {/*            let jsonResponse = await response.json();*/}
                {/*            let dataArray = await jsonResponse;*/}
                {/*            dataArray = dataArray.map((rows: any) => ({*/}
                {/*                ...rows,*/}
                {/*                objectsNames: rows.objects.map((ob: any) => ob.filialAndObj + ';')*/}
                {/*            }))*/}
                {/*            return dataArray;*/}
                {/*        },*/}
                {/*    }}*/}
                {/*    plugins={{*/}
                {/*        gridfilters: true,*/}
                {/*    }}*/}
                {/*    children={[*/}
                {/*        <Column filter="string" locked={false} field="username" text="Логин" width="130"/>,*/}
                {/*        <Column filter="string" locked={false} field="surname" text="Фамилия" width="130"/>,*/}
                {/*        <Column filter="string" locked={false} field="name" text="Имя" width="130"/>,*/}
                {/*        <Column filter="string" locked={false} field="secondName" text="Отчество" width="130"/>,*/}
                {/*        <Column filter="string" locked={false} field="role" text="Роль" width="130"/>,*/}
                {/*        <Column filter="string" locked={false} field="email" text="Почта" width="230"/>,*/}
                {/*        <Column filter="string" locked={false} field="phone" text="Телефон" width="130"/>,*/}
                {/*        <Column filter="string" locked={false} field="objectsNames"*/}
                {/*                text="Объекты" width="330"/>]}*/}
                {/*/>*/}
            </div>
        </Context.Provider>
    );
}